import React from "react";

import FullScreenInit from "components/FullScreenInit";
import { reportError } from "utils/errorHandler";

export class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
    console.log("AppErrorBoundary rendered");
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    reportError(error, {
      errorBoundary: "AppErrorBoundary",
      componentStack: errorInfo.componentStack,
    });
  }


  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <FullScreenInit
          animation="error"
          displayText={"Something went wrong"}
        />
      );
    }

    return this.props.children;
  }
}
